<template>
  <div class="loader">
    <div class="loader__label">Loading...</div>
  </div>
</template>

<script>
export default {
  name: 'Loader',
};
</script>

<style lang="scss" scoped>
.loader {
  @extend %full-fixed;

  background-image: url('/static/texture/static_disturb1.gif');
  background-position: center bottom;
  background-size: cover;

  display: flex;
  align-items: center;
  justify-content: center;

  &__label {
    font-family: 'VHS', sans-serif;
    color: $color-white;
    text-transform: uppercase;

    font-size: rem(80px);
    font-size: calc(80px * var(--rw));
    line-height: rem(80px);
    line-height: calc(80px * var(--rw));
  }
}
</style>
